import React, { useRef, useState } from "react";
import { BsDownload } from "react-icons/bs";
import { Tooltip, Overlay } from "react-bootstrap";
import { saveAs } from "file-saver";
import Base64ToBlob from "../../Formatters/Base64ToBlob";

const download = (arquivo, nomeArquivo, salvar) => {
  let byteArray = arquivo;

  if (typeof byteArray === "string") {
    byteArray = Base64ToBlob(arquivo);
  }

  if (nomeArquivo) {
    const tipoArquivo = nomeArquivo.split(".").pop();

    if (tipoArquivo !== "pdf" || salvar) {
      const file = new Blob([byteArray], { type: `application/${tipoArquivo}` });
      saveAs(file, nomeArquivo);
    } else {
      const file = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(file);
      window.open(url, "", "width=800,height=800");
    }
  } else {
    const file = new Blob([byteArray], { type: "application/pdf" });
    const url = URL.createObjectURL(file);
    window.open(url, "", "width=800,height=800");
  }
};

const FileDownloader = ({ binario, nomeArquivo, tooltip, className, disabled, salvar }) => {
  const target = useRef(null);
  const [showTootip, setShowTooltip] = useState(false);

  return (
    <>
      <span ref={target} onPointerEnter={() => setShowTooltip(true)} onPointerLeave={() => setShowTooltip(false)}>
        <button
          type="button"
          className="btn btn-link pa-0 p-0 mx-1"
          onClick={(e) => {
            e.preventDefault();
            download(binario, nomeArquivo, salvar);
          }}
          alt=""
          disabled={disabled}
        >
          <BsDownload size={16} className={className} />
        </button>
      </span>
      <Overlay target={target.current} show={showTootip} placement="top">
        <Tooltip>{tooltip}</Tooltip>
      </Overlay>
    </>
  );
};

export default FileDownloader;
